(() => {
  if (window.bdmInstantWishlistReady) return;
  window.bdmInstantWishlistReady = true;

  const dialog = document.getElementById("bdm-instant-wishlist");
  const content = dialog?.querySelector("[data-bdm-instant-wishlist-content]");
  const status = dialog?.querySelector("[data-bdm-instant-wishlist-status]");
  const closeButton = dialog?.querySelector("[data-bdm-instant-wishlist-close]");
  if (!dialog || !content || !status || !closeButton) return;

  let opener = null;
  let renderToken = 0;

  function readHandles() {
    if (window.bdmWishlist?.read) return window.bdmWishlist.read();
    try {
      const value = JSON.parse(localStorage.getItem("wishlist") || "[]");
      return Array.isArray(value) ? value : [];
    } catch {
      return [];
    }
  }

  function emptyMarkup() {
    return `
      <div class="bdm-instant-wishlist__empty">
        <i class="feather-heart" aria-hidden="true"></i>
        <strong>Todavía no guardaste favoritos.</strong>
        <p>Guarda las prendas que te inspiran y compáralas sin perder tu recorrido.</p>
        <a href="/collections/all">Descubrir la colección</a>
      </div>
    `;
  }

  async function renderWishlist() {
    const token = ++renderToken;
    const handles = readHandles();
    content.innerHTML = "";

    if (!handles.length) {
      status.textContent = "";
      content.innerHTML = emptyMarkup();
      return;
    }

    status.textContent = `Cargando ${handles.length} ${handles.length === 1 ? "favorito" : "favoritos"}…`;
    dialog.setAttribute("aria-busy", "true");

    const responses = await Promise.allSettled(
      handles.map(async (handle) => {
        const response = await fetch(`/products/${encodeURIComponent(handle)}?view=wishlist`, {
          headers: { "X-Requested-With": "XMLHttpRequest" },
        });
        if (!response.ok) throw new Error(`Producto no disponible (${response.status})`);
        const parsed = new DOMParser().parseFromString(await response.text(), "text/html");
        const product = parsed.querySelector("[data-product-html]");
        if (!product) throw new Error("Tarjeta de producto no encontrada");
        return product.innerHTML;
      })
    );

    if (token !== renderToken) return;
    const cards = responses
      .filter((response) => response.status === "fulfilled")
      .map((response) => response.value);
    const unavailableCount = responses.length - cards.length;

    content.innerHTML = cards.join("");
    status.textContent = unavailableCount
      ? `${cards.length} favoritos disponibles. ${unavailableCount} ya no están disponibles.`
      : `${cards.length} ${cards.length === 1 ? "favorito" : "favoritos"}.`;
    dialog.removeAttribute("aria-busy");
    window.bdmWishlist?.sync?.(content);
  }

  function openWishlist(control) {
    opener = control;
    control.setAttribute("aria-expanded", "true");
    document.documentElement.classList.add("bdm-instant-wishlist-open");
    if (typeof dialog.showModal === "function") {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute("open", "");
      dialog.setAttribute("aria-modal", "true");
    }
    closeButton.focus({ preventScroll: true });
    renderWishlist().catch(() => {
      status.textContent = "No se pudieron cargar tus favoritos. Intentá nuevamente.";
      dialog.removeAttribute("aria-busy");
    });
  }

  function restorePage() {
    document.documentElement.classList.remove("bdm-instant-wishlist-open");
    if (opener) {
      opener.setAttribute("aria-expanded", "false");
      opener.focus({ preventScroll: true });
    }
    opener = null;
  }

  function closeWishlist() {
    if (typeof dialog.close === "function" && dialog.open) dialog.close();
    else {
      dialog.removeAttribute("open");
      restorePage();
    }
  }

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-bdm-instant-wishlist]");
    if (trigger) {
      event.preventDefault();
      openWishlist(trigger);
      return;
    }
    if (event.target.closest("[data-bdm-instant-wishlist-close]")) {
      event.preventDefault();
      closeWishlist();
    }
  });

  document.addEventListener("bdm:wishlist-changed", () => {
    if (dialog.open || dialog.hasAttribute("open")) renderWishlist();
  });

  dialog.addEventListener("click", (event) => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    const inside =
      event.clientX >= bounds.left &&
      event.clientX <= bounds.right &&
      event.clientY >= bounds.top &&
      event.clientY <= bounds.bottom;
    if (!inside) closeWishlist();
  });
  dialog.addEventListener("close", restorePage);
  dialog.addEventListener("cancel", () => window.setTimeout(restorePage, 0));
})();
